import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, Stack, Typography } from '@mui/material';

import { IFanfare } from '../../models/IFanfare';
import ChipExternalLink from '../commons/ChipExternalLink';
import Text from "../commons/Text";

interface IFanfareDialogProps {
    fanfare: IFanfare;
    open: boolean;
    onClose: any;
}

const FanfareDialog = (props: IFanfareDialogProps) => {

    const {fanfare, open, onClose} = props;

    const handleClose = () => onClose();

    return <>
        <Dialog onClose={handleClose} open={open} maxWidth={'md'}>

            <DialogTitle sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Typography gutterBottom component="div" fontFamily={'AllertaStencil'} fontSize={30}>
                    {fanfare.name}
                </Typography>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={2}>

                    <Grid item xs={4} sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Box>
                            <img src={fanfare.image} alt={'Logo ' + fanfare.name} style={{width: '100%'}}/>
                        </Box>
                    </Grid>

                    <Grid item xs={8} sx={{display: 'flex'}}>
                        <DialogContentText>

                            <Box sx={{margin: "30px 0 50px 0"}}>
                                <Text text={fanfare.description ?? ""} fontSize={16}/>
                            </Box>
                        
                            <Stack spacing={1} sx={{alignItems: "flex-start", width: "fit-content"}}>
                                {fanfare.website && (<ChipExternalLink label='Site internet' url={fanfare.website}/>)}
                                {fanfare.facebook && (<ChipExternalLink label='Page Facebook' url={fanfare.facebook}/>)}
                                {fanfare.instagram && (<ChipExternalLink label='Page Instagram' url={fanfare.instagram}/>)}
                                {fanfare.youtube && (<ChipExternalLink label='Espcace Youtube' url={fanfare.youtube}/>)}
                                {fanfare.soundcloud && (<ChipExternalLink label='Espace SoundCloud' url={fanfare.soundcloud}/>)}
                            </Stack>
                            
                        </DialogContentText>
                    </Grid>

                </Grid>
            </DialogContent>

        </Dialog>
    </>
}

export default FanfareDialog;